<template>
  <v-row dense>
    <v-col cols="auto" class="pt-0">
      <v-card>
        <v-card-text class="text-center">
          <ReceiptSheet v-if="order.registrationInfo" :order="order" />
        </v-card-text>
      </v-card>
    </v-col>
    <v-col class="pt-0" v-if="!auth.user.isPartner">
      <v-card>
        <v-card-title>Действия</v-card-title>
        <v-card-actions>
          <v-btn
            :to="{
              name: 'order-new',
              params: { groupId: order.groupId, source: order }
            }"
          >
            Создать копию
          </v-btn>
          <v-spacer />
          <v-btn text @click="cancel">закрыть</v-btn>
        </v-card-actions>
        <v-card-text v-if="hasAdvance">
          <p>
            Создать новый чек, содержащий авансовые позиции текущего чека для
            закрытия предоплаты.
          </p>
          <v-btn text @click="createClosingOrder()">закрыть предоплату</v-btn>
        </v-card-text>
      </v-card>
      <v-card class="mt-2">
        <v-card-title>Коррекция</v-card-title>
        <OrderListComp :items="children" v-if="order.status == 'corrected'" />
        <v-card-text v-else>
          <p>
            <a
              href="https://www.nalog.ru/files/kkt/doc/%D0%9F%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5_%D0%BA_%D0%BF%D0%B8%D1%81%D1%8C%D0%BC%D1%83_%D0%95%D0%94-4-20_15240@.docx"
            >
              Методические указания ФНС
            </a>
          </p>
          <p>
            Отмена ошибочно пробитых чеков выполняется путём формирования нового
            чека с теми же данными, но обратным типом операции (например,
            <em>приход -> возврат прихода</em>).
          </p>
          <p>
            <confirmation-dialog
              @confirm="onDelete"
              title="Отменить чек?"
              color="error"
              :disabled="!confirm"
            >
              <template #text>
                Будет создан новый чек
                <strong>{{ correctionTypeName }}</strong> на сумму
                <strong> {{ order.paymentAmount | currency }} </strong>.
                <v-checkbox
                  label="подтверждаю действия"
                  v-model="confirm"
                ></v-checkbox>
                <v-text-field
                  name="comment"
                  label="Комментарий"
                  v-model="additionalInfo"
                  clearable
                ></v-text-field>
              </template>
              <template #activator="{ on }">
                <v-btn color="error" dark v-on="on">Отменить</v-btn>
              </template>
            </confirmation-dialog>
          </p>
          <p>
            Для исправления данных в чеке проводится отмена ошибочного и
            формируется новый чек с корректными данными.
          </p>
          <v-btn color="warning" @click="correct">Исправить</v-btn>
        </v-card-text>
      </v-card>
      <v-card v-if="order.parentId" class="mt-2">
        <v-card-title>Исправляет</v-card-title>
        <OrderListComp :items="parent && [parent]" />
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import ReceiptSheet from "@/components/ui/ReceiptSheet";
import ds from "@/datastore";
import { getReceiptTypeName } from "@/datastore/enums";
import OrderListComp from "@/components/ui/OrderList";
import { auth } from "@/mixins";
const defaultComment = "Отмена ошибочного чека";
export default {
  name: "OrderReceipt",
  components: { ReceiptSheet, OrderListComp },
  mixins: [auth],
  props: {
    order: { type: Object }
  },
  data() {
    return {
      children: null,
      parent: null,
      additionalInfo: defaultComment,
      confirm: false
    };
  },
  computed: {
    correctionTypeName() {
      return getReceiptTypeName(this.order.correctionReceiptType);
    },
    hasAdvance() {
      return (
        this.order.receipt &&
        this.order.receipt.products.filter(product => product.paymentMethod < 4)
          .length
      );
    }
  },
  async created() {
    if (this.order.status == "corrected") {
      this.children = await ds.findAll("order", {
        groupId: this.order.groupId,
        parentId: this.order.orderId
      });
    }
    if (this.order.parentId) {
      this.parent = await ds.find(
        "order",
        [this.order.groupId, this.order.parentId].join("/"),
        { noValidate: true }
      );
    }
  },
  methods: {
    createClosingOrder() {
      let order = this.order.clone();
      order.receipt.products = order.receipt.products
        .filter(product => product.paymentMethod < 4)
        .map(product => {
          product.paymentMethod = 4;
          return product;
        });
      order.receipt.payment = { prepayment: order.amount };
      this.$router.replace({
        name: "order-new",
        params: { groupId: this.groupId, source: order }
      });
    },
    correct() {
      this.$router.replace({
        name: "order-correct",
        params: { groupId: this.order.groupId, orderId: this.order.orderId }
      });
    },
    async onDelete() {
      let status = await this.order.cancel({
        timeout: 20,
        mandatory: true
      });
      if (status.status == "processed") {
        this.$store.commit(
          "notifications/success",
          "Создан новый чек, отменяющий операцию."
        );
        this.$router.replace({
          name: "order-details",
          params: { groupId: status.groupId, orderId: status.orderId }
        });
      }
    },
    cancel() {
      this.$router.go(-1);
      this.$destroy();
    }
  }
};
</script>
